import React, { useState, useEffect } from "react";
import {
  Button,
  Textarea,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/react";
import { Trash } from "lucide-react";
import AppButton from "../common/AppButton";
import { useFooter } from "../layout/FooterContext";
import AppButtonFooter from "../common/AppButtonFooter";


const PromptsTab = () => {
  const [prompts, setPrompts] = useState([
    "Write a summary of this transcript using clear language.",
    "Rephrase this conversation in a more formal tone.",
    "Extract the key bullet points from this meeting discussion."
  ]);
  const { setFooterContent, setTitle } = useFooter(); 
  

  const [newPrompt, setNewPrompt] = useState("");
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const handleAddPrompt = (onClose) => {
    const trimmed = newPrompt.trim();
    if (trimmed) {
      setPrompts((prev) => [...prev, trimmed]);
      setNewPrompt("");
      onClose();
    }
  };

  useEffect(() => {
    setFooterContent(
      <footer className="flex justify-end gap-2">
        
        <AppButtonFooter
            width="w-[120px]"
            onClick={onOpen}
        >
          Add Prompt
        </AppButtonFooter>
      </footer>
    );
    setTitle("Settings")

    return () => setFooterContent(null); // Clean up on unmount
  }, []);

  const handleDeletePrompt = (index) => {
    setPrompts((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Section */}
        <div className="lg:w-1/3 space-y-4">
          <div>
            <h3 className="text-base font-semibold">Prompts</h3>
            <p className="text-sm text-default-500">
              Create reusable prompts for processing transcripts.
            </p>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex-1 space-y-4">
          

          <div className="space-y-4 max-h-[68vh] overflow-y-auto pr-2">
            {prompts.map((prompt, idx) => (
              <div
                key={idx}
                className="p-4 rounded-xl bg-white "
              >
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-medium text-sm text-gray-800">
                    Prompt {idx + 1}
                  </h4>
                  <button
                    onClick={() => handleDeletePrompt(idx)}
                    className="text-sm text-danger hover:underline"
                  >
                    <Trash className="w-4 h-4 inline-block mr-1 text-red-500" />
                    Delete
                  </button>
                </div>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{prompt}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal for adding new prompt */}
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                Add New Prompt
              </ModalHeader>
              <ModalBody>
                <Textarea
                  label="Prompt"
                  placeholder="Enter a detailed prompt"
                  value={newPrompt}
                  onChange={(e) => setNewPrompt(e.target.value)}
                  minRows={3}
                />
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="bordered" radius="full" onPress={onClose}>
                  Cancel
                </Button>
                <AppButton
                    onClick={() => handleAddPrompt(onClose)}
                    width="w-[120px]"
                    rounded="rounded-[16px]"
                >
                    Add Prompt
                </AppButton>

              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default PromptsTab;
